// "Keep the screen awake while sending": holds a screen wake lock (taken again when the page comes back into view).
export async function stayAwake() {
  let lock = null, on = true;
  const get = async () => { try { lock = (await navigator.wakeLock?.request("screen")) || null; } catch { lock = null; } };
  const back = () => { if (on && document.visibilityState === "visible") get(); };
  await get();
  document.addEventListener("visibilitychange", back);
  return () => { on = false; document.removeEventListener("visibilitychange", back); lock?.release().catch(() => {}); };
}
